'use client';

import * as React from 'react';

import { cn } from './cn';
import { BodySmall } from './typography';
import { EyeIcon } from './EyeIcon';

interface InputProps extends React.ComponentProps<'input'> {
  label?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, label, style, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className={cn('flex flex-col', label && 'gap-2')}>
      {label && <BodySmall className="self-start text-black">{label}</BodySmall>}
      {/* {inputContainer} */}
      <div className="relative">
        <input
          type={inputType}
          className={cn(
            'flex h-[52px] w-full appearance-none rounded-2xl border-2 border-black bg-white px-3 py-1 text-lg shadow-none ring-0 outline-hidden placeholder:text-gray-400 focus:ring-0 focus:ring-transparent focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
            isPassword && '',
            className
          )}
          ref={ref}
          {...props}
        />
        {isPassword && (
          <div
            onClick={() => setShowPassword(!showPassword)}
            className="absolute top-1/2 right-3 size-7 -translate-y-1/2 cursor-pointer"
          >
            <EyeIcon show={showPassword} />
          </div>
        )}
      </div>
    </div>
  );
});
Input.displayName = 'Input';

export { Input };
